import { Injectable } from '@angular/core';
/**
 * 約款別パターンを渡すと対応するrequest項目名を返却するサービス
 * @export
 * @class GetRequiredFieldService
 */
@Injectable({
  providedIn: 'root'
})
export class GetRequiredFieldService {

  constructor() { }

  /**
   * 約款パターン別の必須項目名を取得する。
   * @param {string} yakkanPattern
   * @return {*}  {string}
   * @memberof ElecConvalInfoComponent
   */
  public getRequiredField(yakkanPattern: string): string {
    switch (yakkanPattern) {
      // 低圧契約電流
      case '1':
        return 'conAmpA';
      // 低圧契約容量
      case '2':
        return 'conCapKva';
      // 低圧契約電力
      case '3':
        return 'conEleKw';
      // 該当するものがなければ空文字を返す
      default:
        return '';
    }
  }
}
